import api from './api';

const notificationService = {
  getNotifications: async (page = 1, limit = 20) => {
    const res = await api.get(`/notification?page=${page}&limit=${limit}`);
    return res.data;
  },

  getUnreadCount: async () => {
    const res = await api.get('/notification/unread-count');
    return res.data?.count ?? 0;
  },

  markAsRead: async (id) => {
    const res = await api.patch(`/notification/${id}/read`);
    return res.data;
  },

  markAllAsRead: async () => {
    await api.patch('/notification/read-all');
  },
};

export default notificationService;
